import { render, staticRenderFns } from "./malls.vue?vue&type=template&id=620f5e62&scoped=true&"
import script from "./malls.vue?vue&type=script&lang=js&"
export * from "./malls.vue?vue&type=script&lang=js&"
import style0 from "./malls.vue?vue&type=style&index=0&id=620f5e62&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f5e62",
  null
  
)

export default component.exports